import React from "react";
import PracticsQuestionTopics from "../../../topics/PracticsQuestionTopics";


function DiagramQuestionPhysTopics() {



  return (
    <>

      <PracticsQuestionTopics subject="physics" type="diagrambasedquestions" />

    </>
  );
}

export default DiagramQuestionPhysTopics;